<template>
  <div id="useragreement">
    <div class="areaBlock">
      <p class="title">
        {{$t('useragreement.content')}}
      </p>
      <quilleditor
        class="editerBox"
        v-model="user_agreement_content"
        ref="myTextEditor"
        :options="editorOption"
        @change="onChange"
      >
        <div id="toolbar" slot="toolbar">
          <select class="ql-size">
            <option value="small"></option>
            <option selected></option>
            <option value="large"></option>
            <option value="huge"></option>
          </select>
          <span class="ql-formats">
            <button class="ql-script" value="sub"></button>
          </span>
          <span class="ql-formats">
            <button class="ql-script" value="super"></button>
          </span>
          <span class="ql-formats">
            <button type="button" class="ql-bold"></button>
          </span>
          <span class="ql-formats">
            <button type="button" class="ql-italic"></button>
          </span>
          <span class="ql-formats">
            <button type="button" class="ql-blockquote"></button>
          </span>
          <span class="ql-formats">
            <button type="button" class="ql-list" value="ordered"></button>
          </span>
          <span class="ql-formats">
            <button type="button" class="ql-list" value="bullet"></button>
          </span>
        </div>
      </quilleditor>
    </div>
    <div class="typeBlockSubmit">
      <el-button @click="submit" class="btn1 btn_blue_boder" type="primary" size="small">{{$t('normal_sure')}}</el-button>
    </div>
  </div>
</template>

<script>
import { quillEditor } from "vue-quill-editor";

export default {
  name: 'useragreement',
  data () {
    return {
      doing: false,
      initConfs: null,
      editorOption: {
        theme: "snow",
        modules: {
          toolbar: "#toolbar",
        }
      },
      user_agreement_content: null,
      maxUploadSize: 2 * 1024 * 1024,
      fileName: "file"
    }
  },
  computed: {
    editor() {
      return this.$refs.myTextEditor.quill;
    }
  },
  created () {
    this.initConf()
  },
  components: {
    quilleditor: quillEditor
  },
  methods: {
    onChange() {
      // 内容变化时的处理
    },
    submit () {
      if (this.doing === true) {
        return false
      }
      let params = {
        content: this.user_agreement_content || ''
      }
      if(this.user_agreement_content == this.initConfs.user_agreement_content){
        this.$message(this.$i18n.t('useragreement').success || this.$i18n.t('datashowtype').success)
        return
      }
      let dataLoadIng = this.openFullScreen()
      this.doing = true
      let _this = this
      this.axios.post('/skinMgrSrv/userAgreement/edit', this.formData(params)).then(function (response) {
        _this.doing = false
        if (response.data.code == 0) {
          _this.$message(_this.$i18n.t('useragreement').success || _this.$i18n.t('datashowtype').success)
          _this.initConfs = Object.freeze({
            user_agreement_content: _this.user_agreement_content
          })
        } else {
          _this.$message(_this.$i18n.t('useragreement').fail || _this.$i18n.t('datashowtype').success)
        }
        setTimeout(() => {
          dataLoadIng.close()
        }, 300);
      }).catch(function(res){
        _this.doing = false
        console.log(res)
        setTimeout(() => {
          dataLoadIng.close()
        }, 300);
      });
    },
    initConf () {
      if (this.doing === true) {
        return false
      }
      let dataLoadIng = this.openFullScreen()
      this.doing = true
      let _this = this
      this.axios
        .post("/skinMgrSrv/userAgreement/get", this.formData({}))
        .then(function(response) {
          _this.doing = false;
          if (response.data.code === 0) {
            if(response.data.content){
              _this.user_agreement_content = response.data.content
            }
            _this.initConfs = Object.freeze({
              user_agreement_content: response.data.content || null
            })
          }
          setTimeout(() => {
            dataLoadIng.close()
          }, 300);
        }).catch(function (res) {
          _this.doing = false;
          console.error(res)
          setTimeout(() => {
            dataLoadIng.close()
          }, 300);
        });
    }
  }
}
</script>
<style lang="scss">
  #useragreement{
    width: calc(100% - 40px);
    height: auto;
    background-color: #fff;
    margin: 20px;
    border-radius: 5px;
    padding-top: 60px;
    .areaBlock{
      width: calc(100% - 200px);
      margin: 15px 100px;
      .title {
        font-size: 14px;
        margin-bottom: 15px;
        font-weight: 500;
      }
      .editerBox{
        height: 400px;
        width: 100%;
      }
    }
    .typeBlockSubmit{
      width: calc(100% - 200px);
      height: 60px;
      text-align: left;
      margin: 60px 100px;
    }
    .btn_blue_boder{
      color: #fff;
    }
  }
</style>



// WEBPACK FOOTER //
// src/config/useragreement.vue